module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/icon_clock-9e2dbff72bc4e6a0dfd2340b7f9a9482.svg";